const getCurrentLevelLeaderboardData = (data, currentLevel, difficulty) => {
    switch (currentLevel) {
      case "Cyberpunk City":
        return data.CyberPunkCity[difficulty];
       
      default:
        return data.CyberPunkCity[difficulty];
    }
  };
  export default getCurrentLevelLeaderboardData;
  